import { render, staticRenderFns } from "./CentreMyAccount.vue?vue&type=template&id=f835dd3e&scoped=true&"
import script from "./CentreMyAccount.vue?vue&type=script&lang=js&"
export * from "./CentreMyAccount.vue?vue&type=script&lang=js&"
import style0 from "./CentreMyAccount.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CentreMyAccount.vue?vue&type=style&index=1&id=f835dd3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f835dd3e",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BContainer} from 'bootstrap-vue'
    installComponents(component, {BContainer})
    

export default component.exports